export default "__VITE_ASSET__D036G$MT__"